// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__AKynT","ldio":"Loader_ldio__PAU-J"};